// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_kw-2";
export var aiChatCartContainerExit = "_kw-4";
export var aiChatContainerLarge = "_kw-0";
export var aiChatContainerSmall = "_kw-1";
export var aiChatIcon = "_kw-6";
export var slideInFromRight = "_kw-3";
export var slideOutToRight = "_kw-5";